"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ManagerEditSaveButton = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const Button_1 = require("../../../Button");
const ManagerEditSaveButton = (props) => {
    const { disabled, hidden, handleOnSubmit } = props;
    if (hidden)
        return null;
    return (react_1.default.createElement(Button_1.Button, { icon: 'save', text: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Manager/Edit:Save', defaultMessage: 'Save' }), type: 'submit', onClick: handleOnSubmit, disabled: disabled }));
};
exports.ManagerEditSaveButton = ManagerEditSaveButton;
//# sourceMappingURL=save.js.map